var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg555Bf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    x: 0,
    y: 0,
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.941 219.813H136.133V281.005H74.941z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.247 305.481H136.44V366.672H75.247z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4 391.149H136.592V452.341H75.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.865 134.144H136.057V195.336H74.865z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.827 48.474H136.018V109.666H74.827z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M413.248 249.918c4.928-76.658 73.934-190.163-58.734-190.163-111.137 0-118.595 96.192-118.595 190.163 0 84.969 4.044 186.586 106.527 190.163 142.87 4.986 76.279-104.975 70.802-190.163z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg555Bf);
export default __webpack_public_path__ + "static/media/555bf.7c1e7ae3f50b2d06281d0a1866bc6610.svg";
export { ForwardRef as ReactComponent };